import { Injectable } from '@angular/core'
import { AreaApi } from './base'

@Injectable()
export class VideoAreaApi extends AreaApi{
  apiPath(resourceId: number, areaId = '') {
    return `videos/${resourceId}/areas/${areaId}`
  }
}



// WEBPACK FOOTER //
// ./src/apis/area/video.ts